<!-- Der Host dieser Komponente ist das <dd> einer Zeile der Definitionsliste, das die Aktionen
     zu der Datei traegt; ihr Name steht im <dt> davor, das die Elternkomponente ausgibt. Ein
     <dl> laesst zwischen sich und seinen <dt>/<dd> kein weiteres Element zu, deshalb ist diese
     Komponente ein Attribut des <dd> statt eines Elements. Overlays und Dialoge liegen aus
     demselben Grund innerhalb des <dd>. -->
@if (downloadFile(); as download) {
<his-upload-file-download [value]="download" [disabled]="disableDownload()" />
}
@for (category of iconProperties() | keyvalue: keepCategoryOrder; track category.key) {
<his-select-file-metadata-icon [categoryKey]="category.key" [details]="category.value" />
}
@if (propertyCustomDisplayIcon(); as tpl) {
<ng-container
              *ngTemplateOutlet="tpl; context: { $implicit: file(), properties: customProperties(), disabled: disabled(), readonly: readonly() }" />
}
@if (processProperties() && hasOverlayContent()) {
<button
        type="button"
        hisImage="magnifier_detail_mono"
        class="transparent"
        (click)="resourcePropertiesPanel.toggle($event)"
        title="Eigenschaften anzeigen"
        [disabled]="disabled()"></button>
}
@if (showCommentVisible()) {
<button
        type="button"
        hisImage="COMMENT"
        class="transparent"
        (click)="commentPanel.toggle($event)"
        [title]="commentIconTitle()"></button>
}
@if (editCommentVisible()) {
<!-- Two branches with a static hisImage: the directive appends (instead of replaces)
         inline SVGs on button elements, so the icon name must not change dynamically. -->
@if (hasComment()) {
<button
        type="button"
        hisImage="COMMENT"
        class="transparent"
        (click)="openCommentDialog()"
        [title]="commentIconTitle()"></button>
} @else {
<button
        type="button"
        hisImage="COMMENT_MESSAGE_ONE_COLOR"
        class="transparent"
        (click)="openCommentDialog()"
        [title]="commentIconTitle()"></button>
}
}
<button
        type="button"
        hisImage="PANEL_CLOSE"
        class="transparent"
        (click)="onRemove()"
        [title]="'common.removeOf' | hisUi: filename()"
        [disabled]="disabled() || readonly()"></button>

<p-overlayPanel #resourcePropertiesPanel [showCloseIcon]="true" [dismissable]="true">
    <ng-template pTemplate>
        @if (overlayProperties(); as props) {
        @for (category of props | keyvalue: keepCategoryOrder; track category.key) {
        <div class="hisSelectFile-metadata">
            @if (hasDetailsDisplay(category.key)) {
            <his-select-file-metadata [categoryKey]="category.key" [details]="category.value" />
            } @else {
            <h3>{{ category.value[0].categoryFriendlyName }}</h3>
            <dl class="definitionListGrid">
                @for (
                detail of category.value;
                track detail.propertyKey
                ) {
                <dt>{{ detail.propertyKeyFriendlyName }}</dt>
                <dd>{{ detail.propertyValueFriendlyName }}</dd>
                }
            </dl>
            }
        </div>
        }
        }
        @if (propertyCustomDisplay(); as tpl) {
        <ng-container
                      *ngTemplateOutlet="tpl; context: { $implicit: file(), properties: customOverlayProperties(), disabled: disabled(), readonly: readonly() }" />
        }
    </ng-template>
</p-overlayPanel>

<p-overlayPanel #commentPanel [showCloseIcon]="true" [dismissable]="true">
    <ng-template pTemplate>
        <div class="his-select-file__comment">{{ comment() }}</div>
    </ng-template>
</p-overlayPanel>

<p-dialog
          [visible]="showCommentDialog()"
          [closable]="false"
          [closeOnEscape]="false"
          [dismissableMask]="false"
          [modal]="true"
          [blockScroll]="true"
          [header]="commentDialogTitle()">
    @if (commentHelptextAbove) {
    <div class="infoMessage" [innerHTML]="commentHelptextAbove"></div>
    }
    <his-plam [showLabelTop]="true" [label]="commentLabel" [helptext]="commentHelptext">
        <textarea
                  #content
                  class="textareaWidth100"
                  [ngModel]="commentDraft()"
                  (ngModelChange)="commentDraft.set($event)"></textarea>
    </his-plam>
    @if (commentHelptextBelow) {
    <div class="infoMessage" [innerHTML]="commentHelptextBelow"></div>
    }
    <button type="button" (click)="applyComment()">{{ 'common.apply' | hisUi }}</button>
    <button type="button" (click)="cancelComment()">{{ 'common.cancel' | hisUi }}</button>
</p-dialog>